import Vue from 'vue'
import VueRouter from 'vue-router';
import index from '../components/index/index.vue'
import indexpage from'../components/main/index/index.vue'
import OPACIndex from '../components/OPAC/OPACIndex.vue'
import screenSaver from '../components/screenSaver/screenSaver.vue'
import about from'../components/about.vue'
import ebooktip from'../components/ebooksTip.vue'
import indexsearch from'../components/main/indexsearch/indexsearch.vue'
import ebookinfo from'../components/book/ebookinfo/ebookinfo.vue'
import bookinfo from'../components/book/bookinfo/bookinfo.vue'
import bookcontent from'../components/book/content/content.vue'
import libraryresource from'../components/book/libraryresource/libraryresource.vue'
import booklist from'../components/book/booklist/booklist.vue'
import librarylist from'../components/library/librarylist/librarylist.vue'
import searchbook from'../components/highsearch/searchbook/searchbook.vue'
import searchebook from'../components/highsearch/searchebook/searchebook.vue'
import searchinfor from'../components/highsearch/searchinfor/searchinfor.vue'
import searchlibrary from'../components/highsearch/searchlibrary/searchlibrary.vue'
import ranklist from'../components/rank/ranklist.vue'
import librarypart from'../components/library/librarypart/librarypart.vue'
import introduce from'../components/library/introduce/introduce.vue'
import librarynav from'../components/library/libraryNav/librarynav.vue'
import personal from'../components/person/personnav/personnav.vue'
import borrow from'../components/person/borrow/borrow.vue'
import setup from '../components/person/setup/setup.vue'
import editnote from'../components/person/editnote/editnote.vue'
import history from'../components/person/history/history.vue'
import notelist from'../components/person/notelist/notelist.vue'
import notecontent from'../components/person/notecontent/notecontent.vue'
import ebookcollect from'../components/person/ebookcollect/ebookcollect.vue'
import collection from'../components/person/collection/collection.vue'
import applicant from'../components/person/applicant/applicant.vue'
import apply from'../components/person/apply/apply.vue'
import entrant from'../components/person/entrant/entrant.vue'
import message from'../components/person/message/message.vue'
import othermsg from'../components/person/othermsg/othermsg.vue'
import overduemsg from'../components/person/overduemsg/overduemsg.vue'
import addphone from'../components/addphone/addphone.vue'
import changephone from'../components/changephone/changephone.vue'
import changepwd from'../components/changepwd/changepwd.vue'
import forget from'../components/forget/forget.vue'
import signup from'../components/signup/signup.vue'
import book from'../components/library/book/book.vue'
import inforlist from'../components/library/inforlist/inforlist.vue'
import ebookreading from'../components/book/ebookreading/ebookreading.vue'
import OPACEbookreading from '../components/book/OPACEbookreading/OPACEbookreading.vue'
import infordetails from'../components/information/infordetails/infordetails.vue'
import referbook from'../components/book/referbook/referbook.vue'
import libraryactivitylist from'../components/library/activitylist/activitylist.vue'
import activitydetails from'../components/activity/activitydetails/activitydetails.vue'
import libraryreadercomments from'../components/library/readercomments/readercomments.vue'
import librarymore from'../components/library/librarymore/librarymore.vue'
import indexinforlist from'../components/information/indexinforlist/indexinforlist.vue'
import activitylist from'../components/activity/actlist/actlist.vue'
import error from'../components/error.vue'

Vue.use(VueRouter);
export default new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [{
    name: 'App',
    path: '/',
    redirect: 'indexpage',
    meta: {
      title: '首页'
    }
  }, {
      name: 'OPACIndex',
      path: '/OPACIndex',
      component: OPACIndex,
  },  {
      name: 'screenSaver',
      path: '/screenSaver',
      component: screenSaver
  },{
    name: 'ebookreading',
    path: '/ebookreading',
    component: ebookreading
  }, {
    name: 'OPACEbookreading',
    path: '/OPACEbookreading',
    component: OPACEbookreading
  },{
    name: 'index',
    path: '/index',
    component: index,
    children: [
      {
        name: 'error',
        path: '/error',
        component: error
      },
      {
        name: 'indexpage',
        path: '/indexpage',
        component: indexpage
      },
      {
        name: 'indexsearch',
        path: '/indexsearch',
        component: indexsearch
      },
      {
        name: 'ebooktip',
        path: '/ebooktip',
        component: ebooktip
      },
      {
        name: 'about',
        path: '/about',
        component: about
      },
      {
        name: 'book',
        path: '/book/:type',
        component: booklist
      },
      {
        name: 'ebookinfo',
        path: '/ebookinfo',
        component: ebookinfo
      },
      {
        name: 'weblibrarymore',
        path: '/weblibrarymore',
        component: librarymore
      },
      {
        name: 'librarylist',
        path: '/librarylist',
        component: librarylist
      },
      {
        name: 'webintroduce',
        path: '/webintroduce',
        component: introduce
      },
      {
        name: 'readercomments',
        path: '/readercomments',
        component: libraryreadercomments
      },
      {
        name: 'library',
        path: '/library',
        component: librarynav,
        children: [
          {
            name: 'librarymore',
            path: '/librarymore',
            component: librarymore
          },
          {
            name: 'librarypart',
            path: '/library/librarypart',
            component: librarypart
          },
          {
            name: 'introduce',
            path: '/introduce',
            component: introduce
          },
          {
            name: 'librarybook',
            path: '/library/book/:type',
            component: book
          },
          {
            name: 'inforlist',
            path: '/library/inforlist',
            component: inforlist
          },
          {
            name: 'libraryactivitylist',
            path: '/library/activitylist',
            component: libraryactivitylist
          },
          {
            name: 'libraryreadercomments',
            path: '/library/readercomments',
            component: libraryreadercomments
          },
        ]
      },
      {
        name: 'searchbook',
        path: '/searchbook',
        component: searchbook
      },
      {
        name: 'searchebook',
        path: '/searchebook',
        component: searchebook
      },
      {
        name: 'searchinfor',
        path: '/searchinfor',
        component: searchinfor
      },
      {
        name: 'searchlibrary',
        path: '/searchlibrary',
        component: searchlibrary
      },
      {
        name: 'referbook',
        path: '/referbook',
        component: referbook
      },
      {
        name: 'bookinfo',
        path: '/bookinfo',
        component: bookinfo,
        children: [
          {
            name: 'bookcontent',
            path: '/bookcontent',
            component: bookcontent
          },
          {
            name: 'libraryresource',
            path: 'libraryresource',
            component: libraryresource
          }
        ]
      },
      {
        name: 'ranklist',
        path: '/ranklist',
        component: ranklist
      },
      {
        name: 'personal',
        path: '/personal',
        component: personal,
        children: [
          {
            name: 'borrow',
            path: '/borrow',
            component: borrow
          },
          {
            name: 'setup',
            path: '/setup',
            component: setup
          },
          {
            name: 'editnote',
            path: '/editnote',
            component: editnote
          },
          {
            name: 'history',
            path: '/history',
            component: history
          },
          {
            name: 'notelist',
            path: '/notelist',
            component: notelist
          },
          {
            name: 'notecontent',
            path: '/notecontent',
            component: notecontent
          },
          {
            name: 'collection',
            path: '/collection',
            component: collection,
            children: [
              {
                name: 'ebookcollect',
                path: '/ebookcollect',
                component: ebookcollect
              }
            ]
          },
          {
            name: 'applicant',
            path: '/applicant',
            component: applicant,
            children: [
              {
                name: 'apply',
                path: '/apply',
                component: apply
              },
              {
                name: 'entrant',
                path: '/entrant',
                component: entrant
              }
            ]
          }, {
            name: 'message',
            path: '/message',
            component: message,
            children: [
              {
                name: 'othermsg',
                path: '/othermsg',
                component: othermsg
              },
              {
                name: 'overduemsg',
                path: '/overduemsg',
                component: overduemsg
              }
            ]
          }
        ]
      },
      {
        name: 'addphone',
        path: '/addphone',
        component: addphone,
      },
      {
        name: 'changephone',
        path: '/changephone',
        component: changephone
      },
      {
        name: 'changepwd',
        path: '/changepwd',
        component: changepwd
      },
      {
        name: 'forget',
        path: '/forget',
        component: forget
      },
      {
        name: 'signup',
        path: '/signup',
        component: signup
      },
      {
        name: 'infordetails',
        path: '/infordetails',
        component: infordetails,
      },
      {
        name: 'activitydetails',
        path: '/activitydetails',
        component: activitydetails,
      },
      {
        name: 'indexinforlist',
        path: '/informationlist',
        component: indexinforlist,
      },
      {
        name: 'activitylist',
        path: '/activitylist',
        component: activitylist,
      },
      {
        name: 'part',
        path: '/librarypart',
        component: librarypart
      },
    ]
  }]
})
